import React, { useCallback, useEffect, useMemo, useState, createContext, useContext } from 'react';
import { translations, type Language, type TranslationKeys } from '../i18n/translations';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => any;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
function getNestedValue(obj: any, path: string): any {
  return path.split('.').reduce((current, key) => {
    return current?.[key];
  }, obj);
}
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguageState] = useState<Language>(() => {
    try {
      const stored = localStorage.getItem('helgi-lang');
      if (stored === 'en' || stored === 'is') return stored;
    } catch {}
    return 'is';
  });
  const setLanguage = useCallback((lang: Language) => {
    setLanguageState(lang);
    try {
      localStorage.setItem('helgi-lang', lang);
    } catch {}
  }, []);
  const t = useCallback((key: string): any => {
    const value = getNestedValue(translations[language], key);
    if (value === undefined) {
      console.warn(`Translation missing: ${key} for language: ${language}`);
      return key;
    }
    return value;
  }, [language]);
  const contextValue = useMemo(() => ({
    language,
    setLanguage,
    t
  }), [language, setLanguage, t]);
  return <LanguageContext.Provider value={contextValue} data-id="element-193" data-mp="rqf9uwwheoaf">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}